import React, { useMemo } from 'react';
import { cn } from '@/lib/utils';

/**
 * BetaBadge - Theme-aware Beta tag component
 * - RxHacker: Orange background with white text
 * - GlicHealth: Green background with white text
 */
export const BetaBadge = ({ className }) => {
    const isRxHacker = useMemo(() => {
        if (typeof window === 'undefined') return false;
        const host = window.location.host.toLowerCase();
        const domain = window.location.host.split('.').slice(-2).join('.').toLowerCase();
        return domain === "rxhacker.com" || 
               domain === "nulifespanrx.com" ||
               domain === "localhost:5464" || 
               host === "tempfilter.23byt.es" || 
               host === "reporting.nulifespanrx.com";
    }, []);

    return (
        <span 
            className={cn(
                "inline-flex items-center px-2.5 py-0.5 rounded text-sm font-medium text-white ml-2",
                isRxHacker ? "bg-[#f19f57]" : "bg-[#44b672]",
                className
            )}
        >
            BETA
        </span>
    );
};

